// @ts-nocheck
import { getFormById } from "@store/Framework/Store/Foundation/Components/Form/FormSelector";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useSelector } from "react-redux";

export default (id: string) => {
    return useSelector((state: ApplicationState) => getFormById(state, id));
};
